import { render, staticRenderFns } from "./Redirector.vue?vue&type=template&id=42d9642b&scoped=true&"
import script from "./Redirector.vue?vue&type=script&lang=js&"
export * from "./Redirector.vue?vue&type=script&lang=js&"
import style0 from "./Redirector.vue?vue&type=style&index=0&id=42d9642b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d9642b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VOverlay,VProgressCircular,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d9642b')) {
      api.createRecord('42d9642b', component.options)
    } else {
      api.reload('42d9642b', component.options)
    }
    module.hot.accept("./Redirector.vue?vue&type=template&id=42d9642b&scoped=true&", function () {
      api.rerender('42d9642b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/Redirector.vue"
export default component.exports